// import {UPDATE_CURRENT_GROUP_SAMPLES} from '@/store/mutation.type';
// import {UPDATE_CURRENT_GROUP_MEMBERS} from '@/store/mutation.type';

import Vue from 'vue';
import Component from 'vue-class-component';
import {UPDATE_CURRENT_LEADER_INFO} from '../../../store/mutation.type';

@Component
export default class LeaderCommonStatus extends Vue {
    
    // 返回小组组长的状态信息
    get currentGroupLeaderStatusStore() {
        return this.$store.state['leader_status'].leader_info;
    }

    public getCurrentGroupLeaderStatus(key: string) {
        return this.currentGroupLeaderStatusStore[key];
    }

    public updateCurrentGroupLeaderStatus(key: string, value: any) {
        this.$store.commit(UPDATE_CURRENT_LEADER_INFO, {key, value});
    }
}